import React, { useState, useEffect } from "react";
import { Button, Row, Col, message, Alert, Tooltip } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import estructuraService from "../../services/informeActualizacion/informeActualizacion";
import { ReportGenerator } from "./ReportGenerator";
import { FileDownloader } from "./FileDownloader";

export default function FileStructureReports() {
    const [parsedData, setParsedData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchData = async () => {
        setLoading(true);
        setError("");
        try {
            const data = await estructuraService.obtenerEstructura();
            setParsedData(data);
            message.success(`Estructura cargada correctamente`);
        } catch (err) {
            setError(err.response?.data?.error || "Error al obtener la estructura");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleDownload = (type) => {
        if (!parsedData) return;

        const report =
            type === "folder"
                ? ReportGenerator.generateFolderReport(parsedData)
                : ReportGenerator.generateCompleteStructure(parsedData);

        const filename = FileDownloader.generateFilename(
            type,
            parsedData?.name || "Proyecto"
        );
        FileDownloader.downloadTextFile(report, filename);
    };

    return (
        <div style={{ maxWidth: 900, margin: "0 auto", padding: "24px" }}>
            {error && (
                <Alert
                    message="Error"
                    description={error}
                    type="error"
                    showIcon
                    closable
                />
            )}
            {parsedData && !loading && !error && (
                <Row gutter={[16, 16]} justify="center">
                    <Col xs={24} md={2}>
                        <Tooltip title="Descarga solo las carpetas y subcarpetas hasta nivel 2">
                            <Button
                                block
                                type="primary"
                                icon={<DownloadOutlined />}
                                onClick={() => handleDownload("folder")}
                            >
                            </Button>
                        </Tooltip>
                    </Col>
                    <Col xs={24} md={2}>
                        <Tooltip title="Descarga toda la estructura completa de carpetas y archivos">
                            <Button
                                block
                                type="primary"
                                icon={<DownloadOutlined />}
                                onClick={() => handleDownload("complete")}
                            >
                            </Button>
                        </Tooltip>
                    </Col>
                </Row>)}
        </div>
    );
}
